import styled from 'styled-components/macro';
import { colorCoreGray500 } from '@yme/tokens/colors';
import { elevationTopLvl4 } from '@yme/tokens/elevations';
import { HeadingLevel2 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const ShoppingCartPopupStyled = styled.div `
  position: absolute;
  width: 432px;
  top: 48px;
  right: 0;
  padding: 24px;
  background-color: #fff;
  box-shadow: ${elevationTopLvl4};
`;
export const HeadingLevel2Styled = styled(HeadingLevel2) `
  ${getTextStyles('Play', 700, 24, 28)}
`;
export const OrderSummaryPriceWrapper = styled.div `
  padding: 16px 0;
  border-bottom: 1px solid ${colorCoreGray500};
`;
